import cloneDeep from 'lodash/cloneDeep';

import diff from './diff';
import Pointer from './pointer';
import * as operationFunctions from './patch';

export default function connectRefluxGeoJsonStoreToOlVectorSource(
	store,
	vectorSource,
	geojsonFormat,
	fn = null
) {
	let dataCache = null;

	// listen to store data changes
	if (fn) {
		store.listen((data) => {
			fn(data, (newData) => onDataChange(newData));
		});
	} else {
		store.listen((data) => onDataChange(data));
	}

	function onDataChange(data) {
		if (dataCache) {
			const patch = diff(dataCache, data.geojson, new Pointer());
			if (patch) {
				const identifiedFeatures = {};
				const unidentifiedFeatures = [];

				vectorSource.forEachFeature((feature) => {
					if (feature.getId()) {
						identifiedFeatures[feature.getId()] = feature;
					} else {
						unidentifiedFeatures.push(feature);
					}
				});

				patch.forEach((operation) => {
					const operationFunction = operationFunctions[operation.op];
					if (operationFunction === undefined) {
						console.error('Unknown operation: ' + operation.op);
						return;
					}
					operationFunction({
						operation: operation,
						vectorSource: vectorSource,
						geojsonFormat: geojsonFormat,
						identifiedFeatures: identifiedFeatures,
						unidentifiedFeatures: unidentifiedFeatures,
					});
				});

				vectorSource.changed(); // experimental api
			}
		} else {
			vectorSource.clear();
			vectorSource.addFeatures(
				geojsonFormat.readFeatures(data.geojson, {
					//dataProjection: 'EPSG:25832',
					featureProjection: 'EPSG:3857',
				})
			);
		}
		dataCache = cloneDeep(data.geojson);
	}
}
